// extracted by mini-css-extract-plugin
module.exports = {"grid":"PaidOrdersFilterSection_grid__3Gp0_","fullWidth":"PaidOrdersFilterSection_fullWidth__1CJQ6"};